export default "__VITE_ASSET__61f73b2f__"